module.exports = __webpack_public_path__ + "static/arrow-c3da8a985390d01ecb68b17e27af9a1a.mp4";